var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDistractedDrivingEventsPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Distracted Driving Events",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Distracted Driving Events") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0123,10.5c0,5.8-9.997,14.5-9.997,14.5C10.0153,25,.01825,16.3,.01825,10.5-.11646,4.84036,4.35748,.1413,10.0153,0c5.6578,.1413,10.1318,4.84036,9.997,10.5Z",
    fill: "#d11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13,4H7c-.55127,0-1,.44873-1,1V15c0,.55176,.44873,1,1,1h6c.55176,0,1-.44824,1-1V5c0-.55127-.44824-1-1-1Zm0,1v1H7v-1h6Zm0,2v6H7V7h6ZM7,15v-1h6v1H7Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistractedDrivingEventsPoint);
export default __webpack_public_path__ + "static/media/distracted-driving-events-point.ce1c1b62d3da4ab93df0438211b4c1c6.svg";
export { ForwardRef as ReactComponent };